(function ($, Drupal) {
  'use strict';
  /**
 * Culture - Landing - 2col Formatter
 */

  var cultureLanding2colFormatterV1 = {
    formatter: $('.culture-landing-2col-formatter-v1')
  };

  Drupal.behaviors.cultureLanding2colFormatterV1 = {
    get: function (key) {
      return cultureLanding2colFormatterV1[key];
    },

    set: function (key, val) {
      cultureLanding2colFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

      // do stuff
      });
    }
  };
})(jQuery, Drupal);
